export const initialAbility = [
  {
    action: 'read',
    subject: 'auth',
  },
]

export const initialAuthenticatedAbility = [
    {
      action: 'read',
      subject: 'common',
    },
]

export const _ = undefined
